import { Builder } from "@builder.io/react";
import { FILES } from "i18n/constants";
import dynamic from "next/dynamic";
import { BuilderCreditCardLandingAnimation } from "./client-only";

// Dynamically import the BuilderMarsCoSection component
const BuilderMarsCoSection = dynamic(
  () => import("components/parts/BuilderIO/BuilderMarsCoSection"),
  {
    ssr: true
  }
);

// dynamcially import the Builder Text and Button components
const BuilderText = dynamic(
  () => import("components/parts/BuilderIO/BuilderText"),
  {
    ssr: true
  }
);
const GetStartedBuilderButton = dynamic(
  () => import("components/parts/BuilderIO/BuilderButton/get-started"),
  {
    ssr: true
  }
);
const BuilderButton = dynamic(
  () => import("components/parts/BuilderIO/BuilderButton"),
  {
    ssr: true
  }
);
const BuilderButtonNextLink = dynamic(
  () => import("components/parts/BuilderIO/BuilderButtonNextLink"),
  {
    ssr: true
  }
);

const BuilderDownloadButton = dynamic(
  () => import("components/parts/BuilderIO/BuilderDownloadButton"),
  {
    ssr: true
  }
);

const BuilderCard = dynamic(
  () => import("components/parts/BuilderIO/BuilderCard"),
  {
    ssr: true
  }
);

const BuilderModal = dynamic(
  () => import("components/parts/BuilderIO/BuilderModal"),
  {
    ssr: true
  }
);

const BuilderSocialShareButton = dynamic(
  () => import("components/parts/BuilderIO/BuilderSocialShareButton"),
  {
    ssr: true
  }
);

const BuilderHubspotForm = dynamic(
  () => import("components/parts/BuilderIO/BuilderHubspotForm"),
  {
    ssr: true
  }
);

const BuilderHubspotModal = dynamic(
  () => import("components/parts/BuilderIO/BuilderHubspotModal"),
  {
    ssr: true
  }
);

const BuilderInstitutionalInsightsCards = dynamic(
  () => import("components/parts/BuilderIO/BuilderInstitutionalInsights"),
  {
    ssr: true
  }
);

const BuilderEmailCapture = dynamic(
  () => import("components/parts/BuilderIO/BuilderEmailCapture"),
  {
    ssr: true
  }
);

const BuilderFlipCard = dynamic(
  () => import("components/parts/BuilderIO/BuilderFlipCard"),
  {
    ssr: true
  }
);

const BuilderFAQList = dynamic(
  () => import("components/parts/BuilderIO/BuilderFAQList"),
  {
    ssr: true
  }
);

const BuilderDerivativesChartSwitcher = dynamic(
  () => import("components/parts/BuilderIO/BuilderDerivativesChartSwitcher"),
  {
    ssr: true
  }
);

const BuilderHubbleProvider = dynamic(
  () => import("components/parts/BuilderIO/BuilderHubbleProvider"),
  {
    ssr: true
  }
);

const BuilderDerivativesMetrics = dynamic(
  () => import("components/parts/BuilderIO/BuilderDerivativesMetrics"),
  {
    ssr: true
  }
);

const BuilderDSSlider = dynamic(
  () => import("components/parts/BuilderIO/BuilderDSSlider"),
  {
    ssr: true
  }
);

const BuilderCreditCardHero = dynamic(
  () => import("components/parts/BuilderIO/BuilderCreditCardHero"),
  {
    ssr: true
  }
);

const BuilderCreditCardHeroXrp = dynamic(
  () => import("components/parts/BuilderIO/BuilderCreditCardHeroXrp"),
  {
    ssr: true
  }
);

const BuilderCreditCardHero3Card = dynamic(
  () => import("components/parts/BuilderIO/BuilderCreditCardHero3Card"),
  {
    ssr: true
  }
);

const BuilderCreditCardHeroAmericanBusiness = dynamic(
  () =>
    import("components/parts/BuilderIO/BuilderCreditCardHeroAmericanBusiness"),
  {
    ssr: true
  }
);

const BuilderCreditCardHeroGalaxy = dynamic(
  () => import("components/parts/BuilderIO/BuilderCreditCardHeroGalaxy"),
  {
    ssr: true
  }
);

const BuilderCreditCardHeroSolana = dynamic(
  () => import("components/parts/BuilderIO/BuilderCreditCardHeroSolana"),
  {
    ssr: true
  }
);

const BuilderCreditCardCarousel = dynamic(
  () => import("components/parts/BuilderIO/BuilderCreditCardCarousel"),
  {
    ssr: true
  }
);

const BuilderCreditCardRewardsSummary = dynamic(
  () => import("components/parts/BuilderIO/BuilderCreditCardRewardsSummary"),
  {
    ssr: true
  }
);

const BuilderCreditCardChangeRewards = dynamic(
  () => import("components/parts/BuilderIO/BuilderCreditCardChangeRewards"),
  {
    ssr: true
  }
);

const BuilderCreditCardBitcoinGraph = dynamic(
  () => import("components/parts/BuilderIO/BuilderCreditCardBitcoinGraph"),
  {
    ssr: true
  }
);

const BuilderCreditCardInstantRewards = dynamic(
  () => import("components/parts/BuilderIO/BuilderCreditCardInstantRewards"),
  {
    ssr: true
  }
);

const BuilderCreditCardIntroPromo = dynamic(
  () => import("components/parts/BuilderIO/BuilderCreditCardIntroPromo"),
  {
    ssr: true
  }
);

const BuilderOpenJobs = dynamic(
  () => import("components/parts/BuilderIO/BuilderOpenJobs"),
  {
    ssr: true
  }
);

const BuilderCustomSlider = dynamic(
  () => import("components/parts/BuilderIO/BuilderCustomSlider"),
  {
    ssr: true
  }
);

const BuilderCreditCardSelector = dynamic(
  () => import("components/parts/BuilderIO/BuilderCreditCardSelector"),
  {
    ssr: true
  }
);

const BuilderCarrousel = dynamic(
  () => import("components/parts/BuilderIO/BuilderCarrousel"),
  {
    ssr: true
  }
);

const BuilderMarsCard = dynamic(
  () => import("components/parts/BuilderIO/BuilderMarsCard"),
  {
    ssr: true
  }
);

const BuilderTextWithPopup = dynamic(
  () => import("components/parts/BuilderIO/BuilderTextWithPopup"),
  {
    ssr: true
  }
);

const BuilderEOTCCarousel = dynamic(
  () => import("components/parts/BuilderIO/BuilderEOTCCarousel"),
  {
    ssr: true
  }
);

const BuilderImageViewer = dynamic(
  () => import("components/parts/BuilderIO/BuilderImageViewer"),
  {
    ssr: true
  }
);

const ConditionalRender = dynamic(
  () => import("components/parts/BuilderIO/BuilderConditionalRender"),
  {
    ssr: true
  }
);

Builder.registerComponent(BuilderCard, {
  name: "HubbleCard",
  inputs: [
    {
      name: "variant",
      type: "string",
      enum: ["outlined", "filled", "inverse"]
    },
    { name: "padding", type: "string", enum: ["none", "sm", "md"] },
    { name: "aria-checked", type: "boolean" },
    { name: "customBgColor", type: "color" },
    { name: "data-testid", type: "string" },
    { name: "isCollapsible", type: "boolean" },
    { name: "isRadio", type: "boolean" },
    { name: "overflow", type: "string" },
    {
      name: "flex",
      type: "string",
      defaultValue: "initial",
      helperText:
        "Flex property for the card, helps in adjusting the card height according to the content height as required"
    }
  ],
  defaultChildren: [
    {
      "@type": "@builder.io/sdk:Element",
      component: { name: "Text", options: { text: "" } }
    }
  ]
});

// Register Builder Button component
Builder.registerComponent(BuilderButton, {
  name: "HubbleButton",
  defaultChildren: [
    {
      "@type": "@builder.io/sdk:Element",
      component: { name: "Text", options: { text: "" } }
    }
  ],
  inputs: [
    {
      name: "variant",
      type: "string",
      enum: ["primary", "secondary", "tertiary", "brand"],
      defaultValue: "primary"
    },
    {
      name: "text",
      type: "richText",
      defaultValue: "Click Me",
      localized: true
    },
    { name: "size", type: "string", enum: ["sm", "md", "lg"] },
    { name: "href", type: "string" },
    {
      name: "target",
      type: "string",
      enum: ["_blank", "_self"],
      defaultValue: "_blank"
    }
  ]
});
// [TEMPORARY] Register Get Started Button component
Builder.registerComponent(GetStartedBuilderButton, {
  name: "GetStartedHubbleButton",
  defaultChildren: [
    {
      "@type": "@builder.io/sdk:Element",
      component: { name: "Text", options: { text: "" } }
    }
  ],
  inputs: [
    {
      name: "variant",
      type: "string",
      enum: ["primary", "secondary", "tertiary", "brand"],
      defaultValue: "primary"
    },
    {
      name: "text",
      type: "richText",
      defaultValue: "Click Me",
      localized: true
    },
    { name: "size", type: "string", enum: ["sm", "md", "lg"] },
    {
      name: "target",
      type: "string",
      enum: ["_blank", "_self"],
      defaultValue: "_blank"
    }
  ]
});

// Register this component for use in the Visual Editor
Builder.registerComponent(BuilderText, {
  name: "HubbleText",
  inputs: [
    {
      name: "type",
      type: "string",
      enum: ["Body", "Display", "Heading", "Link"]
    },
    { name: "size", type: "string", enum: ["xl", "lg", "md", "sm", "xs"] },
    { name: "bold", type: "boolean" },
    { name: "color", type: "color" },
    {
      name: "textContent",
      type: "richText",
      defaultValue: "lorem ipsum",
      localized: true
    },
    { name: "href", type: "string" },
    { name: "marketing", type: "boolean", defaultValue: true },
    {
      name: "target",
      type: "string",
      enum: ["_blank", "_self"],
      defaultValue: "_blank"
    },
    {
      name: "as",
      type: "string"
    },
    {
      name: "fontWeight",
      type: "number",
      enum: [
        { label: "100", value: 100 },
        { label: "200", value: 200 },
        { label: "300", value: 300 },
        { label: "400", value: 400 },
        { label: "500", value: 500 },
        { label: "600", value: 600 },
        { label: "700", value: 700 },
        { label: "800", value: 800 },
        { label: "900", value: 900 }
      ]
    }
    // Note: 'marketing' property is omitted as per the provided structure.
  ]
});

Builder.registerComponent(BuilderButtonNextLink, {
  name: "ButtonNextLink",
  inputs: [
    { name: "href", type: "string", defaultValue: "#" },
    { name: "id", type: "string", defaultValue: "button-referral-link" },
    {
      name: "label",
      type: "string",
      defaultValue: "Referral Link",
      localized: true
    },
    { name: "newTab", type: "boolean", defaultValue: false },
    { name: "useReferrerPolicy", type: "boolean", defaultValue: true },
    {
      name: "size",
      type: "string",
      enum: ["sm", "md", "lg"],
      defaultValue: "md"
    },
    {
      name: "variant",
      type: "string",
      enum: ["default", "primary", "secondary", "tertiary", "theme"],
      defaultValue: "primary"
    }
  ]
});

// Register Download Button component
Builder.registerComponent(BuilderDownloadButton, {
  name: "DownloadButton",
  inputs: [
    {
      name: "text",
      type: "string",
      defaultValue: "Download",
      localized: true
    },
    {
      name: "showIcon",
      type: "boolean",
      defaultValue: true
    },
    {
      name: "icon",
      type: "string",
      enum: ["ios", "android"],
      defaultValue: "ios"
    },
    {
      name: "size",
      type: "string",
      enum: ["sm", "md", "lg"],
      defaultValue: "md"
    },
    {
      name: "variant",
      type: "string",
      enum: ["default", "primary", "secondary", "tertiary", "theme"],
      defaultValue: "default"
    }
  ]
});

// Register HubbleModal component

Builder.registerComponent(BuilderModal, {
  name: "Hubble Modal",
  inputs: [
    { name: "isOpen", type: "boolean", defaultValue: false },
    { name: "headerImage", type: "string" },
    { name: "description", type: "string", localized: true },
    { name: "title", type: "string", localized: true },
    { name: "className", type: "string" },
    { name: "testId", type: "string" }
  ],
  defaultChildren: [
    {
      "@type": "@builder.io/sdk:Element",
      component: { name: "Text", options: { text: "" } }
    }
  ]
});

Builder.registerComponent(BuilderSocialShareButton, {
  name: "HubbleSocialShareButton",
  inputs: [
    { name: "title", type: "string" },
    { name: "link", type: "string" },
    {
      name: "platform",
      type: "string",
      enum: ["twitter", "linkedin", "reddit", "link"]
    },
    { name: "customNode", type: "boolean" }
  ],
  defaultChildren: [
    {
      "@type": "@builder.io/sdk:Element",
      component: { name: "Text", options: { text: "" } }
    }
  ]
});

Builder.registerComponent(BuilderHubspotForm, {
  name: "HubbleHubspotForm",
  inputs: [{ name: "hubspotFormId", type: "string" }]
});

Builder.registerComponent(BuilderHubspotModal, {
  name: "HubbleHubspotModal",
  inputs: [
    { name: "isOpen", type: "boolean", defaultValue: false },
    { name: "title", type: "string" },
    { name: "description", type: "string" },
    { name: "hubspotFormId", type: "string" },
    { name: "className", type: "string" },
    { name: "testId", type: "string" }
  ]
});

Builder.registerComponent(BuilderInstitutionalInsightsCards, {
  name: "Institutional Insights Cards",
  inputs: [
    { name: "title", type: "string", defaultValue: "Previous reports" },
    { name: "mobileTitle", type: "string", defaultValue: "Previous reports" }
  ]
});

Builder.registerComponent(BuilderEmailCapture, {
  name: "HubbleEmailCapture",
  inputs: [
    {
      name: "subscriptionType",
      type: "string",
      defaultValue: "general",
      helperText: "Type of subscription"
    },
    {
      name: "submitButtonText",
      type: "string",
      defaultValue: "Subscribe",
      helperText: "Text for the submit button"
    },
    {
      name: "submitButtonPlacement",
      type: "string",
      enum: ["inside", "outside"],
      defaultValue: "inside",
      helperText:
        "Placement of the submit button, inside or outside the input container"
    },
    {
      name: "inputLabelText",
      type: "string",
      localized: true,
      defaultValue: "",
      helperText: "Label for the email input field"
    },
    {
      name: "inputPlaceholder",
      type: "string",
      localized: true,
      defaultValue: "Email address",
      helperText: "Placeholder for the email input field"
    },
    {
      name: "subscribeThanksText",
      type: "string",
      localized: true,
      defaultValue: "Thank you for subscribing!"
    },
    {
      name: "subscribeThanksTextColor",
      type: "color",
      defaultValue: "black"
    }
  ]
});

Builder.registerComponent(BuilderFAQList, {
  name: "FAQList",
  inputs: [
    { name: "title", type: "richText" },
    { name: "dark", type: "boolean", defaultValue: false },
    {
      name: "faqItems",
      type: "list",
      subFields: [
        {
          name: "question",
          type: "string"
        },
        {
          name: "answer",
          type: "richText",
          defaultValue: ""
        }
      ]
    },
    { name: "showTitle", type: "boolean", defaultValue: true }
  ]
});

Builder.registerComponent(BuilderDerivativesChartSwitcher, {
  name: "Derivatives Chart Switcher",
  inputs: [
    {
      name: "symbols",
      type: "list",
      subFields: [{ name: "symbol", type: "string" }]
    }
  ]
});

Builder.registerComponent(BuilderDerivativesMetrics, {
  name: "Derivatives Metrics",
  inputs: [
    {
      name: "symbols",
      type: "list",
      subFields: [{ name: "symbol", type: "string" }]
    }
  ]
});

Builder.registerComponent(BuilderHubbleProvider, {
  name: "HubbleProvider",
  inputs: [
    {
      name: "scheme",
      type: "string",
      enum: ["light", "dark"],
      defaultValue: "light"
    }
  ],
  defaultChildren: [
    {
      "@type": "@builder.io/sdk:Element",
      component: { name: "Text", options: { text: "" } }
    }
  ]
});

Builder.registerComponent(BuilderDSSlider, {
  name: "DS Slider",
  inputs: [
    {
      name: "slides",
      type: "list",
      subFields: [
        { name: "imageAlt", type: "string" },
        { name: "image", type: "file" },
        {
          name: "content",
          type: "uiBlocks",
          defaultValue: []
        },
        {
          name: "maxStepHeight",
          type: "number"
        },
        {
          name: "maxImageWidth",
          type: "string"
        }
      ]
    },
    {
      name: "autoPlay",
      type: "boolean",
      defaultValue: true
    },
    {
      name: "maxStepHeight",
      type: "number"
    },
    {
      name: "showDots",
      type: "boolean",
      defaultValue: false
    }
  ]
});

Builder.registerComponent(BuilderFlipCard, {
  name: "HubbleFlipCard",
  inputs: [
    { name: "frontBackground", type: "color" },
    { name: "backBackground", type: "color" },
    {
      name: "frontContent",
      type: "uiBlocks",
      defaultValue: [
        {
          "@type": "@builder.io/sdk:Element",
          "@version": 2,
          id: "builder-a41feed0cefe461882630fe794b31ebb",
          children: [
            {
              "@type": "@builder.io/sdk:Element",
              component: {
                name: "Text",
                options: { text: "Front Side placeholder text block!" }
              }
            }
          ],
          responsiveStyles: {
            large: {
              display: "flex",
              flexDirection: "column",
              position: "relative",
              flexShrink: "0",
              boxSizing: "border-box",
              height: "max-content",
              width: "auto",
              backgroundColor: "rgba(245, 48, 48, 1)"
            }
          }
        }
      ]
    },
    {
      name: "backContent",
      type: "uiBlocks",
      defaultValue: [
        {
          "@type": "@builder.io/sdk:Element",
          "@version": 2,
          id: "builder-a41feed0cefe461882630fe794b31ebb",
          children: [
            {
              "@type": "@builder.io/sdk:Element",
              component: {
                name: "Text",
                options: { text: "Back Side placeholder text block!" }
              }
            }
          ],
          responsiveStyles: {
            large: {
              display: "flex",
              flexDirection: "column",
              position: "relative",
              flexShrink: "0",
              boxSizing: "border-box",
              height: "max-content",
              width: "auto",
              backgroundColor: "green"
            }
          }
        }
      ]
    },
    {
      name: "borderRadius",
      type: "string",
      helperText: "Border radius for the card; supports px, rem, em, etc"
    },
    {
      name: "frontSideClickable",
      type: "boolean",
      helperText: "Is the whole front side clickable?"
    },
    {
      name: "backSideClickable",
      type: "boolean",
      helperText: "Is the whole back side clickable?"
    }
  ]
});

Builder.registerComponent(BuilderCreditCardHero, {
  name: "BuilderCreditCardHero",
  inputs: [
    {
      name: "headnote",
      type: "richText",
      localized: true,
      defaultValue: "Gemini Credit Card"
    },
    {
      name: "heading",
      type: "richText",
      localized: true,
      defaultValue: "Apply for a Gemini Credit Card"
    },
    {
      name: "disclaimer",
      type: "richText",
      localized: true,
      defaultValue: "Issued by WebBank"
    },
    {
      name: "buttonText",
      type: "richText",
      localized: true,
      defaultValue: "Get Started"
    },
    {
      name: "buttonUrl",
      type: "string",
      defaultValue: "https://creditcard.exchange.gemini.com/credit-card/apply"
    }
  ]
});

Builder.registerComponent(BuilderCreditCardHeroXrp, {
  name: "BuilderCreditCardHeroXrp",
  inputs: [
    {
      name: "headnote",
      type: "richText",
      localized: true,
      defaultValue: "Gemini Credit Card"
    },
    {
      name: "heading",
      type: "richText",
      localized: true,
      defaultValue: "Apply for a Gemini Credit Card"
    },
    {
      name: "subheading",
      type: "richText",
      localized: true,
      defaultValue:
        "Earn up to 4% XRP back on every purchase with no annual fee"
    },
    {
      name: "disclaimer",
      type: "richText",
      localized: true,
      defaultValue: "Issued by WebBank"
    },
    {
      name: "buttonText",
      type: "richText",
      localized: true,
      defaultValue: "Get Started"
    },
    {
      name: "buttonUrl",
      type: "string",
      defaultValue: "https://creditcard.exchange.gemini.com/credit-card/apply"
    }
  ]
});

Builder.registerComponent(BuilderCreditCardHero3Card, {
  name: "BuilderCreditCardHero3Card",
  inputs: [
    {
      name: "headnote",
      type: "richText",
      localized: true,
      defaultValue: "Gemini Credit Card"
    },
    {
      name: "heading",
      type: "richText",
      localized: true,
      defaultValue: "Apply for a Gemini Credit Card"
    },
    {
      name: "subheading",
      type: "richText",
      localized: true,
      defaultValue:
        "Earn up to 4% crypto back on every purchase with no annual fee"
    },
    {
      name: "disclaimer",
      type: "richText",
      localized: true,
      defaultValue: "Issued by WebBank"
    },
    {
      name: "buttonText",
      type: "richText",
      localized: true,
      defaultValue: "Get Started"
    },
    {
      name: "buttonUrl",
      type: "string",
      defaultValue: "https://creditcard.exchange.gemini.com/credit-card/apply"
    }
  ]
});

Builder.registerComponent(BuilderCreditCardHeroAmericanBusiness, {
  name: "BuilderCreditCardHeroAmericanBusiness",
  inputs: [
    {
      name: "heading",
      type: "richText",
      localized: true,
      defaultValue: "The American Business Card"
    },
    {
      name: "subheading",
      type: "richText",
      localized: true,
      defaultValue: "Turn everyday business expenses into crypto rewards"
    },
    {
      name: "boxHeading",
      type: "richText",
      localized: true,
      defaultValue: "Get 1.5% back on every purchase"
    },
    {
      name: "boxSubheading",
      type: "richText",
      localized: true,
      defaultValue: "Unlimited. No caps, no categories."
    },
    {
      name: "disclaimer",
      type: "richText",
      localized: true
    },
    {
      name: "buttonText",
      type: "richText",
      localized: true,
      defaultValue: "Get started"
    },
    {
      name: "buttonUrl",
      type: "string",
      defaultValue: "https://creditcard.exchange.gemini.com/credit-card/apply"
    }
  ]
});

Builder.registerComponent(BuilderCreditCardHeroGalaxy, {
  name: "BuilderCreditCardHeroGalaxy",
  inputs: [
    {
      name: "headnote",
      type: "richText",
      localized: true,
      defaultValue: "Gemini Credit Card"
    },
    {
      name: "heading",
      type: "richText",
      localized: true,
      defaultValue: "Apply for a Gemini Credit Card"
    },
    {
      name: "subheading",
      type: "richText",
      localized: true,
      defaultValue:
        "Earn up to 4% crypto back on every purchase with no annual fee"
    },
    {
      name: "disclaimer",
      type: "richText",
      localized: true,
      defaultValue: "Issued by WebBank"
    },
    {
      name: "tooltipText",
      type: "richText",
      localized: true,
      defaultValue: "4% back on qualifying purchases"
    },
    {
      name: "buttonText",
      type: "richText",
      localized: true,
      defaultValue: "Get Started"
    },
    {
      name: "buttonUrl",
      type: "string",
      defaultValue: "https://creditcard.exchange.gemini.com/credit-card/apply"
    }
  ]
});

Builder.registerComponent(BuilderCreditCardHeroSolana, {
  name: "BuilderCreditCardHeroSolana",
  inputs: [
    {
      name: "headnote",
      type: "richText",
      localized: true,
      defaultValue: "Gemini Credit Card"
    },
    {
      name: "heading",
      type: "richText",
      localized: true,
      defaultValue: "Apply for a Gemini Credit Card"
    },
    {
      name: "subheading",
      type: "richText",
      localized: true,
      defaultValue:
        "Earn up to 4% crypto back on every purchase with no annual fee"
    },
    {
      name: "disclaimer",
      type: "richText",
      localized: true,
      defaultValue: "Issued by WebBank"
    },
    {
      name: "tooltipText",
      type: "richText",
      localized: true,
      defaultValue: "4% back on qualifying purchases"
    },
    {
      name: "buttonText",
      type: "richText",
      localized: true,
      defaultValue: "Get Started"
    },
    {
      name: "buttonUrl",
      type: "string",
      defaultValue: "https://creditcard.exchange.gemini.com/credit-card/apply"
    }
  ]
});

Builder.registerComponent(BuilderCreditCardCarousel, {
  name: "HubbleCreditCardCarousel",
  inputs: [
    { name: "headline", type: "string" },
    { name: "content", type: "string" },
    { name: "localisationFileName", type: "string", defaultValue: FILES.COMMON }
  ]
});

Builder.registerComponent(BuilderCreditCardRewardsSummary, {
  name: "CreditCardRewardsSummary",
  inputs: [
    { name: "headline", type: "richText", localized: true },
    {
      name: "cards",
      type: "list",
      subFields: [
        { name: "backgroundColor", type: "color" },
        { name: "color", type: "color" },
        { name: "percentage", type: "number", max: 9, min: 1, defaultValue: 1 },
        { name: "content", type: "string", localized: true },
        {
          name: "icon",
          type: "string",
          enum: ["Gas", "Dining", "Grocery", "Paw"],
          defaultValue: "Gas"
        },
        { name: "hasSuperScript", type: "boolean" },
        { name: "superScriptValue", type: "string", defaultValue: "1" }
      ]
    }
  ]
});

Builder.registerComponent(BuilderCreditCardChangeRewards, {
  name: "CreditCardChangeRewards"
});

Builder.registerComponent(BuilderCreditCardBitcoinGraph, {
  name: "CreditCardBitcoinGraph",
  inputs: [
    { name: "headline", type: "richText", localized: true },
    { name: "content", type: "richText", localized: true },
    { name: "badgeTextOne", type: "string", localized: true },
    { name: "badgeLabelOne", type: "richText", localized: true },
    { name: "badgeTextTwo", type: "string", localized: true },
    { name: "badgeLabelTwo", type: "richText", localized: true }
  ]
});

Builder.registerComponent(BuilderCreditCardInstantRewards, {
  name: "CreditCardInstantRewards",
  inputs: [
    { name: "mobileHeadline", type: "richText", localized: true },
    { name: "headline", type: "richText", localized: true },
    { name: "content", type: "richText", localized: true }
  ]
});

Builder.registerComponent(BuilderCreditCardIntroPromo, {
  name: "CreditCardIntroPromo",
  inputs: [
    { name: "headnoteOne", type: "richText", localized: true },
    { name: "headnoteTwo", type: "richText", localized: true },
    { name: "mobileHeadnoteTwo", type: "richText", localized: true },
    { name: "headline", type: "richText", localized: true },
    { name: "content", type: "richText", localized: true },
    { name: "buttonText", type: "string", localized: true },
    { name: "footnote", type: "richText", localized: true }
  ]
});

Builder.registerComponent(BuilderOpenJobs, {
  name: "BuilderOpenJobs"
});

Builder.registerComponent(BuilderCustomSlider, {
  name: "HubbleCustomSlider",
  inputs: [
    {
      name: "slides",
      type: "list",
      subFields: [
        {
          name: "content",
          type: "uiBlocks",
          defaultValue: [
            {
              "@type": "@builder.io/sdk:Element",
              "@version": 2,
              children: [
                {
                  "@type": "@builder.io/sdk:Element",
                  component: {
                    name: "Text",
                    options: { text: "Front Side placeholder text block!" }
                  }
                }
              ],
              responsiveStyles: {
                large: {
                  display: "flex",
                  position: "relative",
                  flexShrink: "0",
                  boxSizing: "border-box",
                  height: "200px",
                  marginTop: "20px",
                  width: "200px"
                }
              }
            }
          ]
        }
      ]
    },
    {
      name: "slideDesktopWidth",
      type: "number",
      helperText: "Width of the slide on desktop"
    },
    {
      name: "slideTabletWidth",
      type: "number",
      helperText: "Width of the slide on tablet"
    },
    {
      name: "slideMobileWidth",
      type: "number",
      helperText: "Width of the slide on mobile"
    },
    { name: "slideGap", type: "number", helperText: "Gap between slides" },
    {
      name: "slideToScrollDesktop",
      type: "number",
      helperText: "Number of slides to scroll on desktop"
    },
    {
      name: "slideToScrollTablet",
      type: "number",
      helperText: "Number of slides to scroll on tablet"
    },
    {
      name: "slideToScrollMobile",
      type: "number",
      helperText: "Number of slides to scroll on mobile"
    }
  ]
});

Builder.registerComponent(BuilderCreditCardSelector, {
  name: "CreditCardSelector",
  inputs: [
    { name: "headline", type: "richText", localized: true },
    { name: "content", type: "richText", localized: true }
  ]
});

Builder.registerComponent(BuilderEOTCCarousel, {
  name: "EOTCCarousel",
  inputs: [
    { name: "autoplay", type: "boolean", defaultValue: true },
    {
      name: "slidesToShow",
      type: "number",
      defaultValue: 2.5,
      helperText: "Number of slides to show"
    },
    {
      name: "slides",
      type: "list",
      defaultValue: [
        {
          fields: {
            title: "Slide 1"
          },
          id: "slide-1"
        }
      ]
    }
  ]
});

// Register Custom Carrousel component
Builder.registerComponent(BuilderCarrousel, {
  name: "HubbleCustomCarrousel",
  inputs: [
    {
      name: "controlsColor",
      type: "color",
      helperText: "Color of the controls"
    },
    {
      name: "controlsCustomContent",
      type: "list",
      subFields: [
        {
          name: "content",
          type: "uiBlocks",
          defaultValue: [
            {
              "@type": "@builder.io/sdk:Element",
              "@version": 2,
              children: [
                {
                  "@type": "@builder.io/sdk:Element",
                  component: {
                    name: "Text",
                    options: { text: "Custom controls" }
                  }
                }
              ]
            }
          ]
        }
      ],
      helperText: "Custom content for the controls. Only one item is allowed.",
      onChange: (options: any) => {
        if (options.get("controlsCustomContent").length > 1) {
          return options.set(
            "controlsCustomContent",
            options.get("controlsCustomContent").slice(0, 1)
          );
        }
      }
    },
    {
      name: "controlsPlacement",
      type: "string",
      enum: ["top", "center", "bottom"],
      helperText: "Placement of the controls",
      defaultValue: "bottom"
    },
    {
      name: "controlsGap",
      type: "number",
      helperText: "Gap between controls. In pixels.",
      defaultValue: 4
    },
    {
      name: "controlsSize",
      type: "number",
      helperText: "Size of the controls. In pixels.",
      defaultValue: 8
    },
    {
      name: "controlsWrapperGap",
      type: "string",
      helperText:
        "Gap between content in controls wrapper. One or two values with units. Eg: 10px or 10px 20px"
    },
    {
      name: "controlsWrapperPadding",
      type: "string",
      helperText:
        "Padding of the controls wrapper. Up to four values with units. Eg: 10px 20px 30px 40px"
    },
    {
      name: "controlsWrapperPlacement",
      type: "string",
      enum: ["top", "bottom", "left", "right"],
      helperText: "Placement of the controls wrapper.",
      defaultValue: "bottom"
    },
    {
      name: "controlsWrapperWidth",
      type: "string",
      helperText:
        "Width of the controls wrapper, This will only work if the placement is left or right.",
      defaultValue: "200px"
    },
    {
      name: "slides",
      type: "list",
      subFields: [
        {
          name: "content",
          type: "uiBlocks",
          defaultValue: [
            {
              "@type": "@builder.io/sdk:Element",
              "@version": 2,
              children: [
                {
                  "@type": "@builder.io/sdk:Element",
                  component: { name: "Text", options: { text: "Slide 1" } }
                }
              ],
              responsiveStyles: {
                large: {
                  backgroundColor: "rgba(245, 48, 48, 1)",
                  height: "200px"
                }
              }
            }
          ]
        }
      ]
    },
    {
      name: "slidesAutoPlay",
      type: "boolean",
      helperText: "Auto play the slides transition.",
      defaultValue: false
    },
    {
      name: "slidesEnableScroll",
      type: "boolean",
      helperText:
        "Enable scrolling for slides. Default behavior for tablet and lower screens.",
      defaultValue: false
    },
    {
      name: "slidesTransitionDelay",
      type: "number",
      helperText: "Delay between slide transitions. In seconds.",
      defaultValue: 5
    },
    {
      name: "slidesTransitionDirection",
      type: "string",
      enum: ["left", "right"],
      helperText: "Direction of the slide transition.",
      defaultValue: "right"
    },
    {
      name: "slidesTransitionSpeed",
      type: "number",
      helperText: "Speed of the slide transition. In seconds.",
      defaultValue: 1
    },
    {
      name: "slideWrapperBorderRadius",
      type: "number",
      helperText: "Border radius of the carrousel slide wrapper. In pixels."
    }
  ]
});

// Register Mars Card component
Builder.registerComponent(BuilderMarsCard, {
  name: "MarsCard",
  inputs: [
    {
      name: "borderRadius",
      type: "string",
      helperText: "Border radius for the card; supports px, rem, em, etc"
    },
    {
      name: "content",
      type: "list",
      subFields: [
        {
          name: "content",
          type: "uiBlocks",
          defaultValue: [
            {
              "@type": "@builder.io/sdk:Element",
              "@version": 2,
              children: [
                {
                  "@type": "@builder.io/sdk:Element",
                  component: { name: "Text", options: { text: "Card content" } }
                }
              ]
            }
          ]
        }
      ],
      helperText: "Content for the card",
      onChange: (options: any) => {
        if (options.get("content").length > 1) {
          return options.set("content", options.get("content").slice(0, 1));
        }
      }
    },
    {
      name: "imageAlignment",
      type: "string",
      enum: ["top", "bottom", "left", "right", "center"],
      helperText: "Alignment of the image",
      defaultValue: "center"
    },
    {
      name: "imageAlt",
      type: "string",
      helperText: "Alt text for the image",
      defaultValue: "Mars Image Card",
      required: true
    },
    {
      name: "imageUrl",
      type: "string",
      helperText: "Image URL for the card",
      defaultValue:
        "https://images.ctfassets.net/jg6lo9a2ukvr/2ppzz6BQjP4ugL52lQPXU1/ecc982ee040cff3013c349d6f8bcf8bb/Desktop_Hero_HC_LP.jpg",
      required: true
    },
    {
      name: "maxHeight",
      type: "string",
      helperText: "Maximum height of the image; supports px, rem, em, etc"
    },
    {
      name: "minHeight",
      type: "string",
      helperText: "Minimum height of the image; supports px, rem, em, etc"
    },
    {
      name: "objectFit",
      type: "string",
      enum: ["cover", "contain", "fill", "none"],
      helperText: "Object fit for the image",
      defaultValue: "cover"
    }
  ]
});

Builder.registerComponent(BuilderMarsCoSection, {
  name: "MarsSafariCoSection",
  inputs: [
    {
      name: "borderRadius",
      type: "string",
      helperText: "Border radius for the card; supports px, rem, em, etc"
    },
    {
      name: "content",
      type: "list",
      subFields: [
        {
          name: "content",
          type: "uiBlocks",
          defaultValue: [
            {
              "@type": "@builder.io/sdk:Element",
              "@version": 2,
              children: [
                {
                  "@type": "@builder.io/sdk:Element",
                  component: { name: "Text", options: { text: "Card content" } }
                }
              ]
            }
          ]
        }
      ]
    },
    { name: "backgroundOption", type: "string" }
  ]
});

Builder.registerComponent(BuilderTextWithPopup, {
  name: "TextWithPopup",
  inputs: [
    {
      name: "darkMode",
      type: "boolean",
      helperText: "Enable dark mode for the component.",
      defaultValue: false
    },
    {
      name: "marketing",
      type: "boolean",
      helperText: "Enable marketing mode for the component.",
      defaultValue: false
    },
    {
      name: "popupTitle",
      type: "string",
      helperText: "Title to be displayed in the popup.",
      localized: true
    },
    {
      name: "popupText",
      type: "richText",
      helperText: "Text to be displayed in the popup.",
      defaultValue: "Important Notice",
      localized: true
    },
    { name: "popupTextColor", type: "color" },
    {
      name: "popupTextSize",
      type: "string",
      enum: ["xs", "sm", "md", "lg", "xl"],
      defaultValue: "md"
    },
    {
      name: "text",
      type: "string",
      helperText: "Text to be displayed.",
      defaultValue: "For more information click here",
      localized: true
    },
    {
      name: "textLink",
      type: "string",
      helperText:
        "Text to be displayed as a link that will trigger the popup. This text should be present in the 'text' property.",
      defaultValue: "click here",
      localized: true
    },
    { name: "textColor", type: "color" },
    {
      name: "textSize",
      type: "string",
      enum: ["xs", "sm", "md", "lg", "xl"],
      defaultValue: "md"
    }
  ]
});

Builder.registerComponent(BuilderImageViewer, {
  name: "ImageViewer",
  inputs: [
    {
      name: "imageAlt",
      type: "string",
      helperText: "Alt text for the image",
      defaultValue: "Image Viewer"
    },
    {
      name: "imageUrl",
      type: "file",
      allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
      helperText: "Image URL for the viewer",
      required: true
    },
    {
      name: "maxWidth",
      type: "string",
      helperText: "Maximum width of the image; supports px, rem, em, etc"
    },
    {
      name: "imageAlignment",
      type: "string",
      enum: ["top", "bottom", "left", "right", "center"],
      helperText: "Alignment of the image",
      defaultValue: "center"
    },
    {
      name: "objectFit",
      type: "string",
      enum: ["cover", "contain", "fill", "none"],
      helperText: "Object fit for the image",
      defaultValue: "cover"
    }
  ]
});

Builder.registerComponent(ConditionalRender, {
  name: "ConditionalRender",
  inputs: [
    {
      name: "conditions",
      type: "list",
      defaultValue: [{ condition: "USER_IS_NOT_IN_EU_COUNTRY" }],
      subFields: [
        {
          name: "condition",
          type: "string",
          enum: [
            "USER_IS_NOT_IN_EU_COUNTRY",
            "USER_IS_IN_EU_COUNTRY",
            "USER_IS_NOT_IN_UK",
            "USER_IS_IN_UK",
            "USER_IS_NOT_IN_UK_OR_EU",
            "USER_IS_IN_UK_OR_EU"
          ],
          defaultValue: "USER_IS_NOT_IN_MICA_COUNTRY",
          helperText: "Only render if the given condition is true"
        }
      ]
    }
  ],
  canHaveChildren: true,
  defaultChildren: [
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: "Text",
        options: {
          text: "This is Builder text"
        }
      }
    }
  ]
});

// CLIENT ONLY
Builder.registerComponent(BuilderCreditCardLandingAnimation, {
  name: "CreditCardLandingAnimation"
});
